module.exports = __webpack_public_path__ + "static/media/IconDropdownHeader.f4efd13d.svg";